import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_HeaderAction = _resolveComponent("HeaderAction")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Grid = _resolveComponent("Grid")!
  const _component_AOS = _resolveComponent("AOS")!
  const _component_ThemeChanger = _resolveComponent("ThemeChanger")!
  const _component_MetaInfo = _resolveComponent("MetaInfo")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ThemeChanger, null, {
      default: _withCtx(() => [
        _createVNode(_component_PageHeader, {
          class: "mt-32 lg:mt-48",
          header: _ctx.cms.not_found_h1
        }, null, 8, ["header"]),
        _createVNode(_component_AOS, {
          type: "fade",
          easing: "ease",
          duration: "800",
          delay: "1000"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Grid, null, {
              default: _withCtx(() => [
                _createVNode(_component_Column, { class: "mt-8 mb-32 md:mt-11" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_HeaderAction, {
                      title: _ctx.cms.header_action,
                      "route-text": _ctx.cms.header_button,
                      route: _ctx.Route.Home
                    }, null, 8, ["title", "route-text", "route"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.cms.seo)
      ? (_openBlock(), _createBlock(_component_MetaInfo, {
          key: 0,
          seo: _ctx.cms.seo
        }, null, 8, ["seo"]))
      : _createCommentVNode("", true)
  ], 64))
}